export const MBANK_BRIDGE_VERSION = 1

export const MBANK_BRIDGE_ERROR_CODE = {
  UNAVAILABLE: 'bridgeUnavailable',
} as const

export const MBANK_BRIDGE_ERROR_MESSAGE = {
  DISABLED: 'MBankBridge is disabled by env.',
  UNAVAILABLE: 'MBankBridge is not available.',
  UNSUPPORTED_VERSION: 'MBankBridge version is not supported.',
  INVOKE_FAILED: 'MBankBridge invoke failed.',
} as const
